import { formatBytes } from "@/components/FormUploadInput";

/**
 * Formats file size that can be either a raw number (bytes) or already formatted string
 * @param fileSize - File size as string (could be "1024" or "230.07 KB")
 * @returns Formatted file size string or "-" if invalid
 */
export const formatFileSize = (fileSize: string | undefined | null): string => {
  if (!fileSize) {
    return "-";
  }

  if (/[a-zA-Z]/.test(fileSize)) {
    return fileSize;
  }

  const fileSizeNumber = Number(fileSize);
  return isNaN(fileSizeNumber) ? "-" : formatBytes(fileSizeNumber);
};
